import React, { useState, useEffect, useRef } from "react";
import { Bell } from "lucide-react";

export default function AdminNotifications() {
  const [showDropdown, setShowDropdown] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [hasNew, setHasNew] = useState(false);
  const dropdownRef = useRef(null);
  const lastSeenRef = useRef(Date.now());
  // 🔔 Admin Notification Sound
  const adminSound = useRef(new Audio("/admin.mp3"));
  adminSound.current.volume = 1.0;
// 🔓 Unlock audio on first user interaction (mobile safe)
useEffect(() => {
  const unlock = () => {
    const silent = new Audio();
    silent.play().catch(() => {});
    window.removeEventListener("mousedown", unlock);
    window.removeEventListener("touchstart", unlock);
  };

  window.addEventListener("mousedown", unlock);
  window.addEventListener("touchstart", unlock);

  return () => {
    window.removeEventListener("mousedown", unlock);
    window.removeEventListener("touchstart", unlock);
  };
}, []);
  /* ====================================================
        ✅ Load REAL Notifications From Backend
  ==================================================== */
  const loadNotifications = async () => {
    try {
      const res = await fetch(
  `https://api.speedfollowinfo.com/api/admin/notifications?lastSeen=${lastSeenRef.current}`
);
      const data = await res.json();

      if (data.success) {
        return data.notifications;
      }
    } catch (err) {
      console.error("❌ Load Failed:", err);
    }
    return [];
  };

  // First Load
  useEffect(() => {
    const init = async () => {
      const list = await loadNotifications();
      setNotifications(list);
    };
    init();
  }, []);

  // Auto Refresh Every 10 Sec + Play Sound
useEffect(() => {
  const interval = setInterval(async () => {
    try {
      const res = await fetch(
        `https://api.speedfollowinfo.com/api/admin/notifications?lastSeen=${lastSeenRef.current}`
      );
      const data = await res.json();

      if (data.success) {
        // যদি backend বলে "new" → সাউন্ড বাজাও
        if (data.new === true) {
          adminSound.current.play().catch(() => {});
          setHasNew(true);
          lastSeenRef.current = Date.now();
        }

        setNotifications(data.notifications);
      }
    } catch (err) {
      console.error("❌ Auto Refresh Failed:", err);
    }
  }, 10000);

  return () => clearInterval(interval);
}, []);
  /* ====================================================
        ❌ Clear All Notifications (Backend + UI)
  ==================================================== */
  const clearAllNotifications = async () => {
    try {
      await fetch("https://api.speedfollowinfo.com/api/admin/notifications/clear", {
        method: "DELETE",
      });

      setNotifications([]);
      setHasNew(false);
    } catch (err) {
      console.error("❌ Clear Failed:", err);
    }
  };

  /* ====================================================
        🔥 Hide dropdown when clicking outside
  ==================================================== */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
    setHasNew(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      {/* 🔔 Notification Bell */}
      <button
        onClick={toggleDropdown}
        className="relative text-white hover:text-[#1da1f2] transition-all"
      >
        <Bell size={25} />
        {hasNew && (
          <span className="absolute -top-1 -right-1 w-3.5 h-3.5 bg-[#ff4d4d] rounded-full shadow-md animate-pulse"></span>
        )}
      </button>

      {/* 🧩 Dropdown */}
      {showDropdown && (
        <div className="absolute right-0 mt-3 w-80 bg-[#0f172a] border border-[#1e293b] rounded-xl shadow-2xl overflow-hidden z-50 animate-fade-up">
          <div className="px-4 py-3 border-b border-gray-700 flex justify-between items-center">
            <h3 className="font-semibold text-white">Notifications</h3>

            <button
              onClick={clearAllNotifications}
              className="text-xs text-gray-400 hover:text-red-400 transition"
            >
              Clear All
            </button>
          </div>

          {notifications.length === 0 ? (
            <div className="p-4 text-center text-gray-400">No notifications</div>
          ) : (
            <ul className="max-h-72 overflow-y-auto">
              {notifications.map((note) => (
                <li
                  key={note._id}
                  className="px-4 py-3 border-b border-gray-800 hover:bg-[#1e293b]/50 transition-all"
                >
                  <div className="text-sm font-medium text-[#1da1f2]">
                    {note.type}
                  </div>
                  <div className="text-sm">{note.message}</div>
                  <div className="text-xs text-gray-400 mt-1">
                    {new Date(note.createdAt).toLocaleString()}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}